/* eslint-disable react/display-name */
import React from 'react';
import { ArrowARightIcon16Light } from "../../../internal/icons2022/ArrowARightIcon/ArrowARightIcon16Light";
import { ArrowARightIcon20Light } from "../../../internal/icons2022/ArrowARightIcon/ArrowARightIcon20Light";
import { ArrowARightIcon24Regular } from "../../../internal/icons2022/ArrowARightIcon/ArrowARightIcon24Regular";
import { iconSizer } from "../../../internal/icons2022/iconSizer";
export var ArrowRightIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(ArrowARightIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(ArrowARightIcon20Light, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(ArrowARightIcon24Regular, null);
  }
}, 'ArrowRightIcon');